import { Mail, MessageCircle } from "react-feather";
import { ASK_QUESTINS_DATA } from "../../../Data/Faq";
import { AskOurCommunity, FaqContactUs, Href } from "../../../Constant";
import { LI, UL } from "../../../AbstractElements";
import { Link } from "react-router-dom";

const NavigationOption = () => {
  return (
    <div className="navigation-option">
      <UL>
        {ASK_QUESTINS_DATA.map((item, i) => (
          <LI className="border-0" key={i}>
            <Link to={Href}>{item.icon}{item.title}</Link>
            <span className={item.class}>{item.val}</span>
          </LI>
        ))}
      </UL>
      <hr/>
      <UL>
        <LI className="border-0"><Link to={Href}><Mail />{FaqContactUs}</Link></LI>
        <LI className="border-0"><Link to={Href}><MessageCircle />{AskOurCommunity}</Link></LI>
      </UL>
    </div>
  );
};

export default NavigationOption;
